import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import CustomButton from "../../../components/button";
import { simplePostCall } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";
import Params from "../../../config/Params";
import { toast } from "react-toastify";
// import KeywordSkeleton from "../component/skeletons/keywordSkeleton";

export default function Lessons(props) {

    const { handleNext, details, handleChange, topics, setTopics, lessonsIds, setLessonsIds, setTopicsIds } = props
    const maxSelection = 5;

    // UI states only
    const [customTopic, setCustomTopic] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loadingForCustomSubtopic, setLoadingForCustomSubtopic] = useState(false);

    // Static dummy topics for display
    const [lessons, setLessons] = useState([

    ]);

    const [selectedTopics, setSelectedTopics] = useState([]);

    const handleCheckboxChange = (topic) => {
        const isSelected = details?.selectedLessons.includes(topic?.lessons_name);
        if (isSelected) {
            handleChange("selectedLessons", details?.selectedLessons.filter((t) => t !== topic?.lessons_name));

            setTopics(topics?.filter((topc) => topc?.lessons_name != topic?.lessons_name))

            // setLessonsIds((lessn) => lessn != topic?.lessons_id)

            setLessonsIds(lessonsIds?.filter((lesson) => lesson?.lessons_id != topic?.lessons_id))

            setTopicsIds([])

        } else if (details?.selectedLessons.length < maxSelection) {
            handleChange("selectedLessons", [...details?.selectedLessons, topic?.lessons_name]);
            setTopics([topic, ...topics])

            console.log(lessonsIds);

            setLessonsIds([...lessonsIds, topic])
        }
    };

    const getLessons = () => {

        setIsLoading(true)

        let payload = {
            customer_id: Params.customer_id,
            api_key: Params.api_key,
            class_division_id: details?.grade,
            subject_id: details?.subject,
            curriculum_id: details?.curriculum,
        }

        simplePostCall(ApiConfig?.LESSONS_LIST_API, JSON.stringify(payload)).then((res) => {

            if (res?.lessons_data) {
                setLessons(res?.lessons_data)
            }


            setIsLoading(false)

        })

    }

    useEffect(() => {

        getLessons()

    }, [])

    return (
        <div style={{ backgroundColor: "white" }} className="canLisContentWrap">
            <div className="t-wrapper-div p-4">
                <div className="mb-1">
                    <h5 className="ja-1 mainTitleColr">Lessons:</h5>
                    <p className="ja-2 pt-1" style={{ marginTop: "-7px", color: "#3a4b68" }}>
                        <strong>Note:</strong> You can select a maximum of 5 Lessons.
                    </p>
                </div>

                <div className="do" style={{ borderBottom: "1px solid #dcd9d9", paddingBottom: "24px" }}>
                    {/* <div>
                        <p className="mb-2" style={{ fontSize: "14px", color: "#3a4b68" }}>
                            Add Your Own Broader Topic:
                        </p>

                        <div className="d-flex gap-3">
                            <input
                                name="Custom Broader Topic"
                                disabled={loadingForCustomSubtopic}
                                placeholder="Enter Custom Topic Here"
                                value={customTopic}
                                onChange={(e) => setCustomTopic(e.target.value)}
                                className="w-full p-2 rounded-md border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1"
                                style={{ width: "30%", height: "37px" }}
                            />
                            <div>
                                <CustomButton
                                    isLoading={loadingForCustomSubtopic}
                                    disabled={loadingForCustomSubtopic}
                                    handleClick={() => {
                                        if (customTopic.trim()) {
                                            if (selectedTopics.length < maxSelection) {
                                                setSelectedTopics([customTopic.trim(), ...selectedTopics]);
                                                setCustomTopic("");
                                            }
                                        }
                                    }}
                                    title="Add"
                                    buttonType="tertiory"
                                />
                            </div>
                        </div>
                    </div> */}

                    <div className="p-1 mt-2">
                        <p style={{ fontSize: "14px", fontWeight: "600", color: "#6b778c" }}>
                            Selected Lessons: {details?.selectedLessons.length}/{maxSelection}
                        </p>

                        {isLoading ? (
                            <>
                                <div>
                                    <p className="job_size w-100 text-center">
                                        Lessons are generating. Please wait <Spinner animation="grow" size="sm" />
                                    </p>
                                </div>
                                {/* <KeywordSkeleton /> */}
                            </>
                        ) : (
                            !lessons?.length ?
                                <div className="d-flex justify-content-center mt-2">
                                    <h6>Lesson Not Available</h6>
                                </div>
                                :
                                <div className="row" style={{ marginLeft: "2px" }}>
                                    {lessons.map((topic, index) => (
                                        <div key={index} className="form-check mb-1 col-md-4    ">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={`topic-${index}`}
                                                checked={details?.selectedLessons.includes(topic?.lessons_name)}
                                                onChange={() => handleCheckboxChange(topic)}
                                                disabled={
                                                    details?.selectedLessons.length >= maxSelection &&
                                                    !details?.selectedLessons.includes(topic?.lessons_name)
                                                }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`topic-${index}`}
                                                style={{ fontSize: "13px" }}
                                            >
                                                {topic?.lessons_name}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                        )}
                    </div>
                </div>

                <div className="question-modal-footer d-flex justify-content-end gap-2 mt-3">
                    <CustomButton
                        isLoading={false}
                        title="Back"
                        buttonType="secondary"
                        handleClick={() => { handleNext(1) }}
                    />
                    <CustomButton
                        title="Proceed"
                        isLoading={false}
                        handleClick={() => {

                            if (!details?.selectedLessons?.length) {
                                toast.error('Please Select Lesson')
                                return
                            }
                            handleNext(3)

                        }}
                    />
                </div>
            </div>
        </div>
    );
}

